import { Flex as a } from "../Flex/Flex.js";
import t from "react";
import { Ruler as m } from "./Ruler.js";
import { PriceLabel as f } from "./PriceLabel.js";
import { PriceTooltip as d } from "./PriceTooltip.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const s = 3,
  _ = 0,
  x = [{
    pinposition: "left",
    tooltipStyle: {
      justifyContent: "flex-start"
    }
  }, {
    pinposition: "center",
    tooltipStyle: {
      justifyContent: "center"
    }
  }, {
    pinposition: "right",
    tooltipStyle: {
      justifyContent: "flex-end"
    }
  }],
  P = _ref => {
    let {
      price: r,
      quartile: o,
      percentageFromMedianPrice: e
    } = _ref;
    const {
        tooltipStyle: n
      } = x[o - 1],
      i = e && e >= 0 ? "abaixo" : "acima",
      l = e ? "".concat(Math.abs(e).toFixed(0), "% ").concat(i, " da m\xE9dia") : "Pre\xE7o do an\xFAncio";
    return t.createElement(a, {
      style: n
    }, t.createElement(d, null, t.createElement(f, {
      price: r,
      caption: l
    })));
  };
function E(r, o, e, n, i) {
  const l = Array(o.length).fill("var(--color-neutral-90)"),
    c = r - 1;
  return l[c] = o[c], t.createElement(a, {
    className: "olx-price-reference-ruler__full",
    flexDirection: "column"
  }, t.createElement(P, {
    quartile: r,
    price: e,
    percentageFromMedianPrice: i
  }), t.createElement(m, {
    rectColors: l,
    quartileIndex: c,
    adPrice: e,
    olxPrice: n
  }));
}
const y = _ref2 => {
  let {
    adPrice: r,
    percentageFromMedianPrice: o,
    quartile: e,
    quartileColors: n,
    olxPrice: i,
    hideWithoutPriceInput: l = !1
  } = _ref2;
  const c = l ? t.createElement(t.Fragment, null) : t.createElement(m, {
      rectColors: n.normal,
      quartileIndex: -1,
      adPrice: r,
      olxPrice: i
    }),
    p = !!(e && e >= 1 && e <= s),
    u = r && p && i ? E(e || _, n.highlighted, r, i, o) : c;
  return t.createElement(a, {
    className: "olx-price-reference-ruler__full",
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "flex-end",
    marginBottom: "--spacing-1",
    "data-ds-component": "DS-PriceReferenceRuler",
    "aria-labelledby": "abuyPriceRef-price abuyPriceRef-caption"
  }, u);
};
export { y as PriceReferenceRuler };